import React from 'react';
import * as sc from './styles';

const PdfErrorAlert = () => {
  return (
    <sc.PdfAlertContainer>
      <sc.ErrorIcon />
      <p>Unable to display PDF</p>
    </sc.PdfAlertContainer>
  );
};

export default PdfErrorAlert;
